import {Box, CloseButton, Group, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import type {Artifact, ReadingSelection} from "../../../types";

export function readingSelectionFromArtifacts(artifacts?: Artifact[]): ReadingSelection | null {
    const value = artifacts?.find(a => a.type === "reading_context")?.payload.selection;
    if (!value || typeof value !== "object" || !("text" in value) || typeof value.text !== "string") return null;
    return {
        text: value.text,
        sectionTitle: "sectionTitle" in value && typeof value.sectionTitle === "string" ? value.sectionTitle : undefined,
        truncated: "truncated" in value && value.truncated === true,
    };
}

/** The same quote appears in the composer and on the submitted user message. */
export function ReadingSelectionQuote({selection, onRemove}: {
    selection: ReadingSelection;
    onRemove?: () => void;
}) {
    const {t} = useTranslation();
    return (
        <Group align="flex-start" wrap="nowrap" gap="xs" p="xs" mb="xs"
            bg="var(--mantine-color-gray-0)" style={{borderLeft: "3px solid var(--mantine-color-gray-4)", borderRadius: 4}}>
            <Box style={{flex: 1, minWidth: 0}}>
                {selection.sectionTitle && <Text size="xs" c="dimmed" truncate>{selection.sectionTitle}</Text>}
                <Text component="blockquote" size="sm" m={0} lineClamp={2} title={selection.text}>
                    {selection.text}{selection.truncated ? "…" : ""}
                </Text>
            </Box>
            {onRemove && <CloseButton size="sm" onClick={onRemove}
                aria-label={t("chat.paste_attachment.remove", {defaultValue: "Remove attachment"})}/>}
        </Group>
    );
}
